<script setup>
import Toast from "primevue/toast";
import {onMounted} from "vue";
import {useToast} from "primevue/usetoast";

const props = defineProps([
    'flash',
]);

const toast = useToast()

onMounted(() => {
    if (props.flash) {
        toast.add({
            ...props.flash,
            life: 5000,
        })
    }
})

</script>

<template>
    <div class="h-screen bg-[#F3F0EB] w-full">
        <div class="fixed w-full p-5 z-10">
            <img
                :src="asset('img/logo-black.png')"
                class="block w-[180px] h-[40px] mx-auto"
            />
        </div>

        <div class="flex h-screen justify-center items-center px-5">
            <slot />
        </div>
    </div>

    <Toast />
</template>
